import { BaseControl } from "./BaseControl";
import { Controller } from "./Controller";
import * as ControlFactory from "../Common/ControlFactory";

export class ImageCheckControl extends BaseControl {
    private icon: HTMLElement;

    constructor(protected input: HTMLInputElement, protected controller: Controller, field: string) {
        super(controller, field);

        input.type = "checkbox";
        input.style.display = "none";
        this.icon = input.parentElement.appendChild(ControlFactory.createFontAwesome("check", "i-graphic-check"));
        input.parentElement.style.cursor = "pointer";
        input.parentElement.setAttribute("data-checked", input.checked ? "true" : "false");
        input.parentElement.addEventListener("click", this.onClickEvent);
        this.update();
    }

    onClickEvent = () => {
        let value = this.input.parentElement.getAttribute("data-checked") == "true";
        value = !value;
        this.input.checked = value;
        this.input.parentElement.setAttribute("data-checked", value ? "true" : "false");
        this.update();
        if (this.controller.automaticUpdateModel) {
            this.saveValue(this.input.checked);
        }
    }

    dispose() {
        this.input.parentElement.removeEventListener("click", this.onClickEvent);
    }

    public onUpdate: () => void = null;

    update() {
        let value = this.input.parentElement.getAttribute("data-checked") == "true";
        if (value) {
            this.icon.classList.add("i-check");
        }
        else {
            this.icon.classList.remove("i-check");
        }
        if (this.onUpdate) {
            this.onUpdate();
        }
    }

    updateControlFromModel() {
        let value = this.getModelValue();
        this.input.checked = value;
        this.input.parentElement.setAttribute("data-checked", value ? "true" : "false");
        this.update();
    }

    updateModelFromControl() {
        this.setModelValue(this.input.checked);
    }

    validate() {
    }

    focus() {
        this.input.focus();
    }
}
